export const status = [
  {
    value: 'AGUARDANDO_RESPOSTA_INTERNO',
    label: 'Aguardando resposta'
  },
  {
    value: 'RESPONDIDA',
    label: 'Respondidas'
  },
  {
    value: 'ENCERRADA',
    label: 'Encerradas'
  }
]

export const assuntos = [
  {
    value: 'EM_QUAL_SETOR_SE_ENCONTRA_MEU_PROCESSO',
    label: 'Em qual setor se encontra meu processo?'
  },
  {
    value: 'PORQUE_MEU_PROCESSO_ESTA_PARADO',
    label: 'Por que meu processo está parado?'
  },
  {
    value: 'QUERO_DECLARACAO_TRAMITE_PROCESSUAL',
    label: 'Quero uma declaração de trâmite processual'
  },
  {
    value: 'INFORMAR_PROBLEMA_CADASTRO',
    label: 'Informar um problema nos cadastros'
  },
  {
    value: 'DENUNCIAR_SERVIDOR',
    label: 'Denunciar um servidor'
  },
  {
    value: 'OUTRAS_OPCOES',
    label: 'Outras opções'
  }
]

export const nomesColunasListagem = [
  { label: 'Assunto', prop: 'assunto' },
  { label: 'Responsável', prop: 'responsavel' },
  { label: 'Interessado', prop: 'interessado' },
  { label: 'Data início da conversa', prop: 'dataInicioConversa' },
  { label: 'Data da resposta', prop: 'dataResposta' },
  { label: 'Status', prop: 'status' }
]



// WEBPACK FOOTER //
// ./src/screens/relatorios_ouvidoria/components/conversas/nomesEstaticos.js